/**
 * Post Create Utils
 *
 * Small helpers shared across the post create flow.
 */

import { BoardId } from "../../constants/board-id";
import { Patterns } from "../../constants/patterns";

class PostCreateUtils {
    // Read a File into memory via ArrayBuffer so that Android content:// URIs
    // (which expire after file-picker closes) cannot cause later fetch failures.
    public static async fileToMemory(file: File): Promise<File> {
        try {
            const buf = await new Promise<ArrayBuffer>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result as ArrayBuffer);
                reader.onerror = () => reject(new Error("read"));
                reader.readAsArrayBuffer(file);
            });
            return new File([buf], file.name, { type: file.type || "application/octet-stream" });
        } catch (_e) {
            return file;
        }
    }

    public static getBoardIdFromPath(): string {
        const pathname = window.location.pathname;

        const createMatch = pathname.match(Patterns.BOARD_ID_CREATE_PATH);
        if (createMatch) {
            return createMatch[1];
        }

        const boardMatch = pathname.match(Patterns.BOARD_ID_BOARD_PATH);
        if (boardMatch) {
            return boardMatch[1];
        }

        const simpleMatch = pathname.match(Patterns.BOARD_ID_SIMPLE_PATH);
        if (simpleMatch && simpleMatch[1] !== "posts") {
            return simpleMatch[1];
        }

        return BoardId.REVIEW;
    }
}

export { PostCreateUtils };
